var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 269,
    viewBox: "0 0 295 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14008_88964)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14008_88964)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "#EEF0FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H287C291.418 0 295 3.58172 295 8V44H0V8Z",
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 59,
    width: 167,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 73,
    width: 220,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 89,
    width: 263,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 121,
    width: 54,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 137,
    width: 107,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 169,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 215,
    width: 119,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 185,
    width: 71,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 231,
    width: 71,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 201,
    width: 107,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 153,
    width: 119,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 121.5,
    width: 120,
    height: 123,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 121.5,
    width: 120,
    height: 123,
    rx: 3.5,
    fill: "#2356F6",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 121.5,
    width: 120,
    height: 123,
    rx: 3.5,
    stroke: "#2356F6",
    strokeLinecap: "round",
    strokeDasharray: "2 5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M179.829 163.128C181.173 163.128 182.261 162.44 182.581 161.384V163H185.077V158.472C185.077 157.64 184.469 156.712 183.333 156.712H180.181V158.792H182.181C182.341 158.792 182.437 158.904 182.437 159.08C182.437 159.864 181.189 160.856 179.989 160.856C178.309 160.856 176.949 159.464 176.949 157.4C176.949 155.336 178.309 154.104 180.037 154.104C181.365 154.104 182.181 154.792 182.325 155.88H185.109C185.013 153.384 182.981 151.672 180.069 151.672C177.029 151.672 174.261 153.576 174.261 157.4C174.261 161.224 176.933 163.128 179.829 163.128ZM186.533 163H189.173V154.936H186.533V163ZM186.485 153.944H189.237V151.352H186.485V153.944ZM192.883 163H195.219L198.163 154.936H195.475L194.051 159.624L192.611 154.936H189.939L192.883 163ZM198.923 163H201.563V154.936H198.923V163ZM198.875 153.944H201.627V151.352H198.875V153.944ZM203.001 163H205.641V158.552C205.641 157.752 206.201 157.144 207.001 157.144C207.801 157.144 208.361 157.752 208.361 158.552V163H211.001V157.928C211.001 156.136 209.817 154.808 208.009 154.808C206.953 154.808 206.105 155.24 205.641 155.864V154.936H203.001V163ZM215.959 163.128C216.791 163.128 217.543 162.84 217.975 162.312V163.208C217.975 163.816 217.591 164.248 217.063 164.248H213.351V166.264H217.543C219.399 166.264 220.599 165.192 220.599 163.528V154.936H217.959V155.576C217.527 155.112 216.855 154.808 215.911 154.808C213.639 154.808 212.183 156.392 212.183 158.968C212.183 161.544 213.639 163.128 215.959 163.128ZM214.759 158.968C214.759 157.8 215.415 157.048 216.423 157.048C217.447 157.048 218.103 157.8 218.103 158.968C218.103 160.136 217.447 160.888 216.423 160.888C215.415 160.888 214.759 160.136 214.759 158.968ZM225.648 163H228.496V158.648H232.464V156.216H228.496V154.232H233.536V151.8H225.648V163ZM237.843 163.128C240.355 163.128 242.163 161.352 242.163 158.968C242.163 156.584 240.355 154.808 237.843 154.808C235.331 154.808 233.523 156.584 233.523 158.968C233.523 161.352 235.331 163.128 237.843 163.128ZM236.163 158.968C236.163 157.816 236.835 157.048 237.843 157.048C238.851 157.048 239.523 157.816 239.523 158.968C239.523 160.12 238.851 160.888 237.843 160.888C236.835 160.888 236.163 160.12 236.163 158.968ZM247.236 157.112H248.644V154.936H247.796C246.9 154.936 246.308 155.192 245.844 156.152V154.936H243.204V163H245.844V158.92C245.844 157.784 246.356 157.112 247.236 157.112ZM249.579 163H252.219V158.488C252.219 157.592 252.715 157.016 253.467 157.016C254.219 157.016 254.715 157.592 254.715 158.488V163H257.355V158.488C257.355 157.592 257.851 157.016 258.603 157.016C259.355 157.016 259.851 157.592 259.851 158.488V163H262.491V157.64C262.491 156.152 261.323 154.808 259.563 154.808C258.235 154.808 257.259 155.464 256.827 156.168C256.395 155.288 255.675 154.808 254.443 154.808C253.419 154.808 252.699 155.256 252.219 155.896V154.936H249.579V163Z",
    fill: "#2356F6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 294,
    height: 268,
    rx: 7.5,
    stroke: "#DADCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14008_88964",
    x: -34,
    y: -30,
    width: 363,
    height: 337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14008_88964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14008_88964",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14008_88964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightHalf);
export default __webpack_public_path__ + "static/media/RightHalf.b635d48d03cc4e3b168251bdbf49c390.svg";
export { ForwardRef as ReactComponent };